import React, { useEffect, useState } from "react";
import loaderImgOne from "../../assets/loader/loader-img-1.png";
import loaderImgTwo from "../../assets/loader/loader-img-2.png";
import loaderImgThree from "../../assets/loader/loader-img-3.png";
import loaderImgFour from "../../assets/loader/loader-img-4.png";
import loaderImgFive from "../../assets/loader/loader-img-5.png";
import "./ApiLoader.css";

export default function ApiLoader(props) {
  // console.log('Loder file props', props.apiLoaderInfo);

  // console.log('Oops file props', props.oopsLoaderInfo);
console.log(props.loaderStep);
  const [loaderProcessOne, setLoaderProcessOne] = useState(false);
  const [loaderProcessTwo, setLoaderProcessTwo] = useState(false);
  const [loaderProcessThree, setLoaderProcessThree] = useState(false);
  const [loaderProcessFour, setLoaderProcessFour] = useState(false);
  // const [loaderProcessFive, setLoaderProcessFive] = useState(false);

  const [firstLoadingComplete, setfirstLoadingComplete] = useState(false);
  const [secondLoadingComplete, setsecondLoadingComplete] = useState(false);
  const [thirdLoadingComplete, setthirdLoadingComplete] = useState(false);
  const [fourthLoadingComplete, setfourthLoadingComplete] = useState(false);
  // const [fifthLoadingComplete, setfifthLoadingComplete] = useState(false);

  function firstLoading() {
      setLoaderProcessOne(true);
  }

  function secondLoading() {
    setLoaderProcessTwo(true);
  }

  function thirdLoading() {
    setLoaderProcessThree(true);
  }

  function fourthLoading() {
    setLoaderProcessFour(true);
  }

  // function fifthLoading() {
  //   setTimeout(() => {
  //     if (props.apiLoaderInfo) {
  //       setfifthLoadingComplete(true);
  //     }
  //   }, 10000);
  //   setLoaderProcessFive(true);
  // }

  // useEffect(() => {
  //   firstLoading(secondLoading);
  // }, []);
console.log('props.loaderStep', props.loaderStep);
  useEffect(() => {
    if (props.loaderStep === null || props.loaderStep === undefined) {
      // Start with first step
      setLoaderProcessOne(true);
    } else {
      // Get the maximum loader step
      const maxStep = Array.isArray(props.loaderStep) 
        ? Math.max(...props.loaderStep) 
        : props.loaderStep;

      console.log('Maximum loader step:', maxStep);

      // Set all previous steps as complete and current step as in progress
      switch (maxStep) {
        case 2:
          setfirstLoadingComplete(true);
          setLoaderProcessOne(true);
          setLoaderProcessTwo(true);
          break;
        case 3:
          setfirstLoadingComplete(true);
          setsecondLoadingComplete(true);
          setLoaderProcessOne(true);
          setLoaderProcessTwo(true);
          setLoaderProcessThree(true);
          break;
        case 4:
          setfirstLoadingComplete(true);
          setsecondLoadingComplete(true);
          setthirdLoadingComplete(true);
          setLoaderProcessOne(true);
          setLoaderProcessTwo(true);
          setLoaderProcessThree(true);
          setLoaderProcessFour(true);
          break;
        case 5:
          setfirstLoadingComplete(true);
          setsecondLoadingComplete(true);
          setthirdLoadingComplete(true);
          setfourthLoadingComplete(true);
          setLoaderProcessOne(true);
          setLoaderProcessTwo(true);
          setLoaderProcessThree(true);
          setLoaderProcessFour(true);
          break;
        default:
          setLoaderProcessOne(true);
      }
    }
  }, [props.loaderStep]);


  return (
    <div className="spinner-loader">
      {/* <img className='loader-css' src={GifForLoader} alt="" /> */}
      <div className="loader-body">
        {props.oopsLoaderInfo ? (
          <>
            <div className="oops-details-bg ">
              <h3>
                <span className="">Oops! </span> Something went wrong.
              </h3>
              <p>Please try again</p>
            </div>
          </>
        ) : (
          <div className="d-flex align-items-center justify-content-between">
           

            <div className={loaderProcessOne ? "icon-body" : "icon-body-dis"}>
              <div className="icon-sp">
                <img
                  src={loaderImgTwo}
                  alt="loader-image-one"
                  className="img-fluid icon-sz"
                />
              </div>
              <div className="running-loader">
                <div
                  className={
                    loaderProcessOne
                      ? firstLoadingComplete
                        ? "progress-bar-loader bar-loader-complete"
                        : "progress-bar-loader indeterminate"
                      : "progress-bar-loader"
                  }
                ></div>
              </div>
              <h4>Dynamically generating prompt</h4>
            </div>

            <div className={loaderProcessTwo ? "icon-body" : "icon-body-dis"}>
              <div className="icon-sp">
                <img
                  src={loaderImgThree}
                  alt="loader-image-one"
                  className="img-fluid icon-sz"
                />
              </div>
              <div className="running-loader">
                <div
                  className={
                    loaderProcessTwo
                      ? secondLoadingComplete
                        ? "progress-bar-loader bar-loader-complete"
                        : "progress-bar-loader indeterminate"
                      : "progress-bar-loader"
                  }
                ></div>
              </div>
              <h4>Calling Open AI API</h4>
            </div>

            <div className={loaderProcessThree ? "icon-body" : "icon-body-dis"}>
              <div className="icon-sp">
                <img
                  src={loaderImgFour}
                  alt="loader-image-one"
                  className="img-fluid icon-sz"
                />
              </div>
              <div className="running-loader">
                <div
                  className={
                    loaderProcessThree
                      ? thirdLoadingComplete
                        ? "progress-bar-loader bar-loader-complete"
                        : "progress-bar-loader indeterminate"
                      : "progress-bar-loader"
                  }
                ></div>
              </div>
              <h4>Transforming the responses</h4>
            </div>

            <div className={loaderProcessFour ? "icon-body" : "icon-body-dis"}>
              <div className="icon-sp">
                <img
                  src={loaderImgFive}
                  alt="loader-image-one"
                  className="img-fluid icon-sz"
                />
              </div>
              <div className="running-loader">
                <div
                  className={
                    loaderProcessFour
                      ? fourthLoadingComplete
                        ? "progress-bar-loader bar-loader-complete"
                        : "progress-bar-loader indeterminate"
                      : "progress-bar-loader"
                  }
                ></div>
              </div>
              <h4>Generating the final files</h4>
              {props.loaderStep === 4 && (
                <div className="loadingMsg">{props?.loaderMessage}</div>

              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}




//////////>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
// import React, { useEffect, useState } from "react";
// import loaderImgTwo from "../../assets/loader/loader-img-2.png";
// import loaderImgThree from "../../assets/loader/loader-img-3.png";
// import loaderImgFour from "../../assets/loader/loader-img-4.png";
// import loaderImgFive from "../../assets/loader/loader-img-5.png";
// import "./ApiLoader.css";

// export default function ApiLoader(props) {
//   console.log(props.loaderStep);

//   const [activeStep, setActiveStep] = useState(1);
  
//   const [loaderProcess, setLoaderProcess] = useState({
//     step1: false,
//     step2: false,
//     step3: false,
//     step4: false,
//   });

//   const [loadingComplete, setLoadingComplete] = useState({
//     step1: false,
//     step2: false,
//     step3: false,
//     step4: false,
//   });

//   useEffect(() => {
//     if (props.loaderStep) {
//       setActiveStep((prevStep) => Math.max(prevStep, props.loaderStep));
//     }
//   }, [props.loaderStep]);

//   useEffect(() => {
//     setLoaderProcess({
//       step1: activeStep >= 1,
//       step2: activeStep >= 2,
//       step3: activeStep >= 3,
//       step4: activeStep >= 4,
//     });

//     setLoadingComplete({
//       step1: activeStep > 1,
//       step2: activeStep > 2,
//       step3: activeStep > 3,
//       step4: activeStep > 4,
//     });
//   }, [activeStep]);

//   return (
//     <div className="spinner-loader">
//       <div className="loader-body">
//         {props.oopsLoaderInfo ? (
//           <div className="oops-details-bg">
//             <h3>
//               <span className="">Oops! </span> Something went wrong.
//             </h3>
//             <p>Please try again</p>
//           </div>
//         ) : (
//           <div className="d-flex align-items-center justify-content-between">
//             <LoaderStep 
//               image={loaderImgTwo} 
//               process={loaderProcess.step1} 
//               complete={loadingComplete.step1} 
//               text="Dynamically generating prompt" 
//             />

//             <LoaderStep 
//               image={loaderImgThree} 
//               process={loaderProcess.step2} 
//               complete={loadingComplete.step2} 
//               text="Calling Open AI API" 
//             />

//             <LoaderStep 
//               image={loaderImgFour} 
//               process={loaderProcess.step3} 
//               complete={loadingComplete.step3} 
//               text="Transforming the responses" 
//             />

//             <LoaderStep 
//               image={loaderImgFive} 
//               process={loaderProcess.step4} 
//               complete={loadingComplete.step4} 
//               text="Generating the final files" 
//             />

//             {activeStep === 4 && (
//               <div className="loadingMsg">{props?.loaderMessage}</div>
//             )}
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// function LoaderStep({ image, process, complete, text }) {
//   return (
//     <div className={process ? "icon-body" : "icon-body-dis"}>
//       <div className="icon-sp">
//         <img src={image} alt="loader-image" className="img-fluid icon-sz" />
//       </div>
//       <div className="running-loader">
//         <div
//           className={
//             process
//               ? complete
//                 ? "progress-bar-loader bar-loader-complete"
//                 : "progress-bar-loader indeterminate"
//               : "progress-bar-loader"
//           }
//         ></div>
//       </div>
//       <h4>{text}</h4>
//     </div>
//   );
// }

